module.exports = __webpack_public_path__ + "static/img/gkjb_logo.c3a9765.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/gkjb_logo.jpg
// module id = kRop
// module chunks = 1